const debounce = (fn, timeout, invokeAsap) => {
  let timer;

  return function debounceFn() {
    const args = arguments;

    if (invokeAsap && !timer) {
      fn(...args);
    }

    clearTimeout(timer);

    timer = setTimeout(() => {
      if (!invokeAsap) {
        fn(...args);
      }
      timer = null;
    }, timeout);
  };
};

export default debounce;



// WEBPACK FOOTER //
// ./src/misc/debounce.js